import AbTest from "../../tracking/abTest";
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const abTestArtisanPricingName = 'lp_ab_artisanPricingPageFees'
export const abTestArtisanPricingOldVar = 'withoutFees'
export const abTestArtisanPricingNewdVar = 'withFees'

const setCookies = () => {
    if (!cookies.get(abTestArtisanPricingName)) {
        cookies.set(abTestArtisanPricingName, Math.random() > 0.5 ? abTestArtisanPricingOldVar : abTestArtisanPricingNewdVar, { path: '/', domain: process.env.REACT_APP_COOKIES_ALL_SUBDOMAIN })
    }
}
export const setAbTestArtisanPricing = (nameAbTest = abTestArtisanPricingName) => {
    setCookies()
    if (typeof window[nameAbTest] === 'undefined') {
        const abTestArtisanPricing = new AbTest()
        if (typeof (abTestArtisanPricing) !== 'undefined') {
            // Enregistrement du test
            abTestArtisanPricing.registerFromCookie(nameAbTest, abTestArtisanPricingNewdVar);
        }
    }
}

export const getAbtestArtisanPricing = (nameAbTest = abTestArtisanPricingName) => {
    return window[nameAbTest]
}



// WEBPACK FOOTER //
// ./src/components/utils/abTestInstance.js